import { useDashboards } from './composables/useDashboards'
import { buildAccountCenterRoute, buildCustomDashboardRoute } from './service/dashboardRoute'

import { useAccount, useWorkspace } from '@/features/account'

/** Dynamic New Front sidebar groups. Providers are evaluated reactively by useNavigation(). */
export function createDashboardNavItemsProvider(
  options: {
    includeCreate?: boolean
    includeAccountCenters?: boolean
  } = {},
) {
  const dashboards = useDashboards()
  const account = useAccount()
  const workspace = useWorkspace()

  return () => {
    const routeContext = {
      accountId: account.accountId.value ?? null,
      workspaceId: workspace.workspaceId.value ?? null,
      workspaceAccountId: workspace.workspace.value?.account_id ?? null,
    }
    const dashboardChildren = [
      ...(options.includeCreate === false ||
      workspace.workspaceId.value === null ||
      workspace.workspaceId.value === undefined
        ? []
        : [
            {
              labelKey: 'dashboards.nav.createNew',
              navKey: 'dashboardCreate',
              to: { name: 'CustomDashboardCreate' },
            },
          ]),
      ...dashboards.workspaceDefinitions.value.map((dashboard) => ({
        ...(dashboard.name ? { label: dashboard.name } : { labelKey: 'dashboards.page.untitled' }),
        navKey: `dashboard-${dashboard.id}`,
        to: buildCustomDashboardRoute(dashboard, routeContext),
      })),
    ]
    const items =
      dashboardChildren.length > 0
        ? [
            {
              labelKey: 'dashboards.nav.dashboards',
              icon: 'block-quote',
              iconWeight: 'light' as const,
              navKey: 'dashboards',
              children: dashboardChildren,
            },
          ]
        : []

    if (options.includeAccountCenters !== false && dashboards.accountCenters.value.length > 0) {
      items.push({
        labelKey: 'dashboards.nav.accountCenter',
        icon: 'chart-user',
        iconWeight: 'light' as const,
        navKey: 'accountCenter',
        children: dashboards.accountCenters.value.map((center) => ({
          ...(center.name ? { label: center.name } : { labelKey: 'dashboards.nav.accountCenter' }),
          navKey: `account-center-${center.id}`,
          to: buildAccountCenterRoute(center),
        })),
      })
    }

    return items
  }
}
